<template>
  <div>
    <select class="select-field w-select" v-model="$parent.info[slg]">
      <option value="">Choose a {{fname}}</option>
      <option v-for="item in $parent.schema[index].validations.options" :key="item.id" :value="item.id">{{item.name}}</option>
    </select>
  </div>
</template>

<script>
export default {
	name: 'Option',
  props: ['slg', 'fname','index'],
  created(){
    console.log(this.slg)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>